
<!-- 
SurveyModal.vue
功能：問卷視窗
作者：i9400538 陳博承
完成：2022-07-14
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
        </div>
        <div
          :class="{ 'section-loading': isLoading }"
          class="iframe-container"
          style="height: 100%; overflow-y: auto"
          id="div-survey"
        >
          <iframe
            :src="frameSrc"
            frameborder="0"
            :key="'iframe-' + frameSrc"
            id="iframe-survey"
            :height="height"
            width="795px"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//service
import { getSurveyUrl, updateSurveyRecord } from "@/service";
export default {
  name: "SurveyModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    csid: {
      type: String,
      default: "",
    },
    ser_no: {
      type: String,
      default: "001",
    },
  },
  data() {
    return {
      isLoading: true,
      frameSrc: "", //問卷系統的網址
      quest_no: "", //問卷編號
      quest_type: "", //問卷類型
      spot_ser_no: "", //問卷識別碼
      height: "",
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    },
  },
  watch: {
    open: function (val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    //初始化
    init() {
      this.isLoading = true;
      this.frameSrc = "";
      this.quest_no = "";
      this.quest_type = "";
      this.spot_ser_no = "";
      if (this.isBox == true) {
        this.height = "550px";
      } else {
        this.height = "750px";
      }
      this.doGetSurveyUrl();
    },
    //取得問卷url
    doGetSurveyUrl() {
      getSurveyUrl(this.$store.state.userInfo.id, this.csid, this.ser_no, "CRM").then(
        (result) => {
          this.isLoading = false;
          if (result.header && result.header.status == "200") {
            let rtnMap = result.body || {};
            this.frameSrc = rtnMap.quest_url || ""; //問卷系統的網址
            this.quest_no = rtnMap.quest_no || ""; //問卷編號
            this.quest_type = rtnMap.quest_type || ""; //問卷類型
            this.spot_ser_no = rtnMap.spot_ser_no || ""; //問卷識別碼
          } else {
            this.setToastMsg(result.header.message);
          }
        }
      );
    },
    //更新問卷填寫狀況
    doUpdateSurveyRecord() {
      if (!this.quest_no || !this.spot_ser_no) {
        return;
      }
      this.isLoading = true;
      updateSurveyRecord(
        this.$store.state.userInfo.id,
        this.quest_no,
        this.spot_ser_no
      ).then((result) => {
        this.isLoading = false;
        if (result.header && result.header.status == "200") {
          this.$emit("refresh");
        } else {
          this.setToastMsg(result.header.message);
        }
      });
    },
  },
  mounted() {
    window.onmessage = this.doUpdateSurveyRecord;
  },
};
</script>

<style lang="scss" scoped>
#iframe-survey {
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  overflow-x: auto;
  z-index: 11;
}
</style>